// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__11zKo","buttons":"PendingPaymentAlert_buttons__1SOOo"};